/*******************************************************************************
 * @ngdoc  provider
 * @name   csm.books.OurOrg.provider:AppConfig
 * @description
 * Configuration properties for ourOrg. This contains the default tabs and creates
 * the settings object. Settings should be set using the AppConfig provider in the
 * individual app to show/hide elements accordingly. Also additional tabs can be
 * added using the addTab() function.
 *******************************************************************************/
/* @ngInject */ export function AppConfigProvider() {
  var tabs = {};
  var tabList = [];

  var settings = {
    allowSigs: false /** Show/hide signatures checkbox */,
    displayName: null /** Display name of organization type */,
    hideActNumber: false /** Show/hide account number box in displayed accounts */,
    showCode: false /** Show/hide School Code input */,
    showExitGrade: false /** Show/hide Exit Grade input */,
    showFEIN: false /** Show/hide FEIN input */,
    showSalesTax: false /** Show/hide Sales Tax input */,
    showSecStID: false /** Show/hide Sec of State ID input */,
    showStID: false /** Show/hide State Unit ID input */,
    showUnitID: false /** Show/hide National PTA ID input */,
    usePOS: false /** Boolean to allow use of POS */
  };

  /*------------------------------------------*/
  /* Default tabs for each organization type. */
  /*------------------------------------------*/
  addTab({
    id: 'organization',
    title: 'Our School',
    templateUrl: 'organizationTab.html',
    content: '<organization></organization>'
  });
  addTab({
    id: 'processors',
    title: 'Payment Processors',
    templateUrl: 'processorsTab.html',
    content: '<processors></processors>'
  });

  this.addTab = addTab;
  this.settings = settings;
  this.tabs = tabs;

  /*-------------------------------------------------*/
  /* Add the templateUrl and content to the          */
  /* $templateCache in the app. When the templateUrl */
  /* is not found, the content will be used.         */
  /*-------------------------------------------------*/
  this.$get = ['$templateCache', function ($templateCache) {
    for (var p in tabs)
      $templateCache.put(tabs[p].templateUrl, tabs[p].content);

    /*--------------------------------------*/
    /* Make the settings and tabList        */
    /* available in the AppConfig provider. */
    /*--------------------------------------*/
    return {
      settings: this.settings,
      tabList: tabList
    }
  }];

/*****************************************************************************
* addTab
/**
* @ngdoc    function
* @name     addTab
* @methodOf csm.books.OurOrg.provider
* @param    {Object} config  Configuration to add to the AppConfig
* @description
* This will add a tab to be displayed. 
*****************************************************************************/

  function addTab(config) {
    tabList.push(config);
    tabs[config.id] = config;
  }
}
